import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';


@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor() { }

  camposIguales(campo1:string, campo2:string){

    return (formGroup: AbstractControl): ValidationErrors | null =>{
     
      const pass1 = formGroup.get(campo1)?.value
      const pass2 = formGroup.get(campo2)?.value

      if(pass1 !== pass2){
        formGroup.get(campo2)?.setErrors({noIguales: true})
        return {
          noIguales: true
        }
      }
      formGroup.get(campo2)?.setErrors(null)

      return null
    }
  }

   equalsValidator(campo1:string, campo2:string): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
      const value: any = control.get(campo1)?.value;
      const otherValue: any = control.get(campo2)?.value;

      return otherValue === value ? null : { 'notEquals': { value, otherValue } };
    };
  }
}
